import React from 'react';
import MonitoringDashboard from '../components/dashboard/MonitoringDashboard';

export default function MonitoramentoPage() {
  return <MonitoringDashboard />;
}